import React from "react";
import styled, { keyframes } from "styled-components";

const ChartWrapper = ({ data, height = 300, children }) => {
  const hasData = data && data.length > 0;

  if (!hasData) {
    return (
      <EmptyState style={{ height }}>
        <SkeletonLoader />
        <p>Aguardando dados do filtro de data...</p>
      </EmptyState>
    );
  }

  return <div style={{ height, width: "100%" }}>{children}</div>;
};

export default ChartWrapper;

//
// 🎨 Styled Components
//

const shimmer = keyframes`
  0% { background-position: -450px 0; }
  100% { background-position: 450px 0; }
`;

const SkeletonLoader = styled.div`
  width: 50%;
  height: 14px;
  border-radius: 8px;
  background: #f0f0f0;
  background-image: linear-gradient(
    90deg,
    #f0f0f0 0px,
    #e0e0e0 40px,
    #f0f0f0 80px
  );
  background-size: 600px;
  animation: ${shimmer} 1.5s infinite linear;
  margin-bottom: 12px;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #888;
  font-size: 1rem;
  font-style: italic;
  text-align: center;
  border-radius: 12px;
  background: #fafafa;
  border: 1px dashed #ddd;
`;
